module.exports = __webpack_public_path__ + "img/stress_1.2c01829e.jpg";